/**
 * PROJECT REGISTRY — constants & shared helpers
 * Centralizes the option sets (department, status, priority) and small mappers
 * shared by ProjectsList and ProjectDetail so both views stay in sync.
 */

// Fixed department list (with project-code prefix). Mirrors the backend
// PROJECT_DEPT_PREFIX map in server.js — keep both in sync.
export const DEPARTMENTS = [
  { value: 'hr',               label: 'HR',               prefix: 'HR' },
  { value: 'call_center',      label: 'Call Center',      prefix: 'CALL' },
  { value: 'accounting',       label: 'Accounting',       prefix: 'ACC' },
  { value: 'finance',          label: 'Finance',          prefix: 'FIN' },
  { value: 'sales',            label: 'Sales',            prefix: 'SALES' },
  { value: 'marketing',        label: 'Marketing',        prefix: 'MKT' },
  { value: 'it',               label: 'IT',               prefix: 'IT' },
  { value: 'operations',       label: 'Operations',       prefix: 'OPS' },
  { value: 'administration',   label: 'Administration',   prefix: 'ADMIN' },
  { value: 'customer_support', label: 'Customer Support', prefix: 'CS' },
  { value: 'other',            label: 'Other',            prefix: 'OTH' },
];

export const STATUS_OPTIONS = [
  { value: 'draft',     label: 'Skicë',        color: 'default',   dot: '#94A3B8' },
  { value: 'planned',   label: 'Planifikuar',  color: 'info',      dot: '#0EA5E9' },
  { value: 'active',    label: 'Aktiv',        color: 'success',   dot: '#10B981' },
  { value: 'on_hold',   label: 'Pezulluar',    color: 'warning',   dot: '#F59E0B' },
  { value: 'review',    label: 'Në rishikim',  color: 'secondary', dot: '#8B5CF6' },
  { value: 'completed', label: 'Përfunduar',   color: 'primary',   dot: '#2563EB' },
  { value: 'cancelled', label: 'Anuluar',      color: 'error',     dot: '#DC2626' },
];

export const PRIORITY_OPTIONS = [
  { value: 'low',      label: 'E ulët',    color: '#64748B' },
  { value: 'medium',   label: 'Mesatare',  color: '#2563EB' },
  { value: 'high',     label: 'E lartë',   color: '#EA580C' },
  { value: 'critical', label: 'Kritike',   color: '#DC2626' },
];

// Ngjyrat që mund të marrë një projekt (shfaqen te lista, kartela e punonjësit, kalendari).
export const PROJECT_COLORS = ['#4F46E5', '#0EA5E9', '#10B981', '#F59E0B', '#EF4444', '#EC4899', '#8B5CF6', '#14B8A6', '#64748B'];

const _dep = new Map(DEPARTMENTS.map((d) => [d.value, d]));
const _st  = new Map(STATUS_OPTIONS.map((s) => [s.value, s]));
const _pr  = new Map(PRIORITY_OPTIONS.map((p) => [p.value, p]));

export const departmentLabel = (v) => _dep.get(String(v || '').toLowerCase())?.label || (v || '—');
export const statusOption    = (v) => _st.get(String(v || '').toLowerCase()) || { value: v, label: v || '—', color: 'default' };
export const priorityOption  = (v) => _pr.get(String(v || '').toLowerCase()) || { value: v, label: v || '—', color: '#64748B' };

/**
 * Datë e lexueshme: `05.08.2026`, jo `2026-08-05`.
 *
 * Moduli i projekteve e shfaqte datën në formën e bazës, kurse çdo ekran tjetër
 * i Nexuma-s përdor ditë.muaj.vit. Dy formate te i njëjti aplikacion e detyrojnë
 * lexuesin ta përkthejë datën sa herë ndërron faqe.
 */
export const fmtDate = (d) => {
  const s = String(d ?? '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s)) return '—';
  const [y, m, dd] = s.split('-');
  return `${dd}.${m}.${y}`;
};

export const workerName = (w) =>
  w ? `${w.FirstName || w.first_name || ''} ${w.LastName || w.last_name || ''}`.trim() || w.Email || `#${w.Id || w.id}` : '';
